import {
  FiSearch,
  FiMessageSquare,
  FiFolder,
  FiUsers,
  FiCalendar,
  FiBarChart2,
} from "react-icons/fi";
import { MdOutlineDashboard, MdOutlineSettings } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { GiSoccerField } from "react-icons/gi";
import { IoMdTrophy } from "react-icons/io";

export const NAV_LINKS = [{ name: "Home", path: "/" }];

export const SIDEBAR_LINKS = [
  { name: "Dashboard", path: "#", icon: MdOutlineDashboard },
];
